// extracted by mini-css-extract-plugin
module.exports = {"Label":"InputLabel_Label__lSRST","InfoIcon":"InputLabel_InfoIcon__qjtRV","hint":"InputLabel_hint__MFJGv","Tooltip":"InputLabel_Tooltip__yvaZl"};